import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useParams, useNavigate } from 'react-router-dom';
import { registraNavigate } from '../../utils/vai';
import Caricamento from '../common/Caricamento';
import RegistrazioneDaLink from './RegistrazioneDaLink';
import ContoInAttesa from '../Registrazione/ContoInAttesa';
import ResetPasswordSuccess from './ResetPasswordSuccess';
import ResetPasswordEmail from './ResetPasswordEmail';
import ForgotPassword from './ForgotPassword';
import ActivateAccountEmail from './ActivateAccountEmail';
import CheckPassword from './CheckPassword';
import RequireAuth from './RequireAuth';
import ConVoce, { PrimaPaginaDelConto } from './ConVoce';
import { skinConCasino, skinConScommesse } from '../../moduli/leggi';
import MyAccountPlaceholder from "./MyAccountPlaceholder";
import ApriPrenotazione from "./ApriPrenotazione";
import AccessoDaLink from "./AccessoDaLink";
import FinestraImportante from "./FinestraImportante";
import ChatAssistenza from "../Assistenza/ChatAssistenza";
import Vetrina from "../Vetrina/Vetrina";
import PaginaTesto from "../Vetrina/PaginaTesto";
import PaginaChiSiamo from "../Vetrina/PaginaChiSiamo";
import SeSezione from "../Shell/SeSezione";
import Lobby from "../Casino/Lobby";
import PaginaGioco from "../Casino/PaginaGioco";
import Ricerca from "../Casino/Ricerca";
import SportBetby from "../SportBetby/SportBetby";
import PaginaCategoria from "../Vetrina/PaginaCategoria";
import Promozioni from "../Pagine/Promozioni";
import SpazioVip from "../Pagine/SpazioVip";
import Tornei from "../Pagine/Tornei";
import PaginaScritta from "../Pagine/PaginaScritta";
import i18next from 'i18next';

/* LE PAGINE CHE SI SCARICANO SOLO QUANDO SERVONO. Sport, live, conto e
   giocate sono la parte piu' pesante del pacchetto (MyBets da sola vale
   piu' di tutto il casino'), e chi apre la Home o la lobby non le usa:
   prima si scaricavano tutte alla prima apertura, adesso ognuna arriva al
   suo primo indirizzo. Home, lobby, gioco, ricerca e categorie restano
   nel pacchetto principale: sono la prima cosa che si vede. */
const caricaSport = () => import("../SportMenu/SportContainer");
const SportContainer = React.lazy(caricaSport);
/* CHI ARRIVA DIRETTAMENTE SULLO SPORT non aspetta che il sito finisca di
   partire (la skin, le parole) per cominciare a scaricare la pagina: il suo
   pacchetto parte subito, insieme al resto. Su un telefono lento, misurato,
   e' piu' di un secondo prima di vedere l'elenco. */
if (typeof window !== 'undefined' && /^\/(sport|p)(\/|$)/.test(window.location.pathname)) {
    caricaSport().catch(() => {});
}
const LiveSportContainer = React.lazy(() => import("../LiveSport/LiveSportContainer"));
const MyAccount = React.lazy(() => import("./MyAccount"));
const ListaUtenti = React.lazy(() => import("./ListaUtenti"));
const MyTickets = React.lazy(() => import("./MyTickets"));
const OddsPage = React.lazy(() => import("./OddsPage"));
const ListaMovimenti = React.lazy(() => import("./ListaMovimenti"));
const ReportCasino = React.lazy(() => import("./ReportCasino"));
const GirocontoRapido = React.lazy(() => import("./GirocontoRapido"));
const Cassa = React.lazy(() => import("./Cassa"));
const MioProfilo = React.lazy(() => import("./MioProfilo"));
const MyBets = React.lazy(() => import("./MyBets"));
const Sicurezza = React.lazy(() => import("./Sicurezza"));
const Messaggi = React.lazy(() => import("./Messaggi"));

/* Chi sta fuori dal router (la griglia delle quote, un componente a classe)
   cambia pagina con vai(): qui gli si da' la funzione, una volta. */
function RegistraNavigate() {
    const navigate = useNavigate();
    useEffect(() => { registraNavigate(navigate); return () => registraNavigate(null); }, [navigate]);
    /* LO SPORT SI PREPARA IN ANTICIPO. Sulle skin con le scommesse e' la
       pagina piu' aperta dopo la Home: quando il browser non ha altro da
       fare se ne scarica il pacchetto, cosi' toccando Sport non si aspetta
       anche quello. Sulle skin senza sport non si scarica niente. */
    useEffect(() => {
        if (!skinConScommesse()) return undefined;
        const quandoLibero = window.requestIdleCallback || ((fai) => setTimeout(fai, 2500));
        const annulla = window.cancelIdleCallback || clearTimeout;
        const id = quandoLibero(() => { caricaSport().catch(() => {}); });
        return () => annulla(id);
    }, []);
    return null;
}

/* LA PAGINA DELL'EVENTO sta DENTRO la pagina Sport: stesso menu, stessa
   schedina, al centro la partita. Il numero arriva dall'indirizzo. */
function SportConEvento({ history, userService }) {
    const { numero } = useParams();
    return (
        <SportContainer
            history={history}
            name="SportContainer"
            userService={userService}
            path={'sport'}
            numeroEvento={numero}/>
    );
}

class Main extends React.Component {
    render() {
        const { userService, history } = this.props;
        return (
            <div className="main-container">
                <RegistraNavigate/>
                {/* Il messaggio importante si apre da solo, su qualunque pagina. */}
                <FinestraImportante/>
                {/* La bolla della chat di assistenza, per chi e' entrato. */}
                <ChatAssistenza/>
                <React.Suspense fallback={<Caricamento forma={'barra'}/>}>
                <Routes>
                    <Route path='/my-account' element={
                        <RequireAuth userService={userService}>
                            <div className={'my-account-container'}>
                                <MyAccount userService={userService} />
                            </div>
                        </RequireAuth>
                    }>
                        {/* OGNI PAGINA DEL CONTO CHIEDE LA SUA VOCE DEL GETTONE (ConVoce,
                            utils/permessi.js): la stessa che il menu usa per mostrarla.
                            Chi scrive l'indirizzo a mano senza la voce trova «non
                            disponibile». La Cassa ne vuole una fra due: versare o
                            prelevare. */}
                        {/* La pagina d'ingresso del conto era il menu ridisegnato a
                            bottoni. Tolto quello, non resta niente da mostrare qui:
                            si va dritti sulla prima pagina che il gettone concede. */}
                        <Route index element={<PrimaPaginaDelConto />} />
                        <Route path="profilo" element={<ConVoce voce="SITE_PROFILE_VIEW"><MioProfilo userService={userService} /></ConVoce>} />
                        <Route path="lista-utenti" element={<ConVoce voce="SITE_NETWORK_VIEW"><ListaUtenti /></ConVoce>} />
                        <Route path="saldi-utenti" element={<ConVoce voce="SITE_NETWORK_VIEW"><MyAccountPlaceholder title={i18next.t('Saldi utenti')} /></ConVoce>} />
                        <Route path="utenti-non-confermati" element={<ConVoce voce="SITE_NETWORK_VIEW"><MyAccountPlaceholder title={i18next.t('Utenti non confermati')} /></ConVoce>} />
                        <Route path="cambio-password" element={<Navigate to="/my-account/sicurezza" replace />} />
                        {/* Password, PIN e antieffrazione erano tre voci con un campo
                            ciascuna: ora una pagina sola. I tre indirizzi vecchi
                            restano e portano li', cosi' un segnalibro non si rompe. */}
                        <Route path="sicurezza" element={<ConVoce voce="SITE_PASSWORD_MANAGE"><Sicurezza userService={userService} /></ConVoce>} />
                        {/* Telegram sta nella pagina Sicurezza, sotto la password. */}
                        <Route path="accesso-telegram" element={<Navigate to="/my-account/sicurezza" replace />} />
                        <Route path="lista-scommesse" element={<ConVoce voce="SITE_BETS_VIEW" quando={skinConScommesse}><MyBets userService={userService} /></ConVoce>} />
                        <Route path="lista-movimenti" element={<ConVoce voce="SITE_MOVEMENTS_VIEW"><ListaMovimenti userService={userService} /></ConVoce>} />
                        {/* Versamento e prelievo stanno nella Cassa (criptovaluta, NOWPayments):
                            i due indirizzi vecchi portano li', cosi' un segnalibro non si rompe.
                            Prelievo apre gia' sulla linguetta Preleva. */}
                        <Route path="versamento" element={<Navigate to="/my-account/cassa" replace />} />
                        <Route path="prelievo" element={<Navigate to="/my-account/cassa?verso=preleva" replace />} />
                        <Route path="cassa" element={<ConVoce voce={['SITE_DEPOSIT', 'SITE_WITHDRAW']}><Cassa /></ConVoce>} />
                        {/* Messaggistica: avvisi e promozioni della piattaforma, e le preferenze. */}
                        <Route path="messaggi" element={<ConVoce voce="SITE_MESSAGES_VIEW"><Messaggi /></ConVoce>} />
                        <Route path="messaggi/preferenze" element={<ConVoce voce="SITE_MESSAGES_VIEW"><Messaggi vista="preferenze" /></ConVoce>} />
                        <Route path="giroconto" element={<ConVoce voce="SITE_TRANSFER"><GirocontoRapido /></ConVoce>} />
                        <Route path="report" element={<ConVoce voce="SITE_REPORTS_VIEW" quando={skinConCasino}><ReportCasino /></ConVoce>} />
                        {/* DA COLLEGARE: il meccanismo delle commissioni non c'e' in nessun
                            servizio. La voce del menu (utils/myAccountSections.js) e questa
                            rotta chiedono gia' la stessa voce del catalogo. */}
                        <Route path="commissioni" element={<ConVoce voce={['SITE_COMMISSIONS_VIEW', 'SITE_COMMISSIONS_MANAGE']}>
                            <MyAccountPlaceholder title={i18next.t('Commissioni')}>
                                <p className="light-grey">{i18next.t('Il sistema delle commissioni verrà fatto: oggi non c’è in nessun servizio.')}</p>
                            </MyAccountPlaceholder></ConVoce>} />
                        <Route path="antieffrazione" element={<Navigate to="/my-account/sicurezza" replace />} />
                        <Route path="cambio-pin" element={<Navigate to="/my-account/sicurezza" replace />} />
                        <Route path="my-bets" element={<ConVoce voce="SITE_BETS_VIEW" quando={skinConScommesse}><MyBets userService={userService} /></ConVoce>} />
                        <Route path="balance-history" element={<ConVoce voce="SITE_MOVEMENTS_VIEW"><ListaMovimenti userService={userService} /></ConVoce>} />
                        <Route path="withdraw-deposit" element={<Navigate to="/my-account/cassa" replace />} />
                    </Route>
                    {/* OGNI SEZIONE HA LA SUA PORTA (SeSezione): se la skin
                        l'ha spenta, l'indirizzo rimanda alla Home. Le chiavi
                        sono quelle del catalogo dei moduli. */}
                    <Route path='/sport' element={
                        <SeSezione chiave={'sport'}>
                            <div className="sport-container">
                                <SportContainer
                                    history={history}
                                    name="SportContainer"
                                    userService={userService}
                                    path={'sport'}/>
                            </div>
                        </SeSezione>
                    }/>
                    {/* Una partita al suo indirizzo: il numero evento e' quello
                        che si cerca e si cita. La pagina e' quella di Sport,
                        con la partita al centro. */}
                    <Route path='/sport/evento/:numero' element={
                        <SeSezione chiave={'sport'}>
                            <div className="sport-container">
                                <SportConEvento history={history} userService={userService}/>
                            </div>
                        </SeSezione>
                    }/>
                    {/* Il collegamento di una giocata prenotata: lascia il
                        codice e manda su /sport, dove sta la schedina. */}
                    <Route path='/p/:codice' element={<ApriPrenotazione />} />
                    {/* /register apre la finestra «Registrati» (come /login
                        apre «Accedi»), anche al ritorno da Telegram
                        (?code=…). Il modulo (Registrazione/Registrati) legge
                        la skin: campi e canali li decide il backoffice. Il
                        vecchio Register.js resta nel repo ma non e' piu'
                        collegato. */}
                    <Route path='/register' element={<RegistrazioneDaLink userService={userService} />} />
                    {/* /login apre la finestra «Accedi» (con «Accedi con
                        Telegram»), non la pagina vecchia: Login.js resta nel
                        repo ma non e' piu' collegato. */}
                    <Route path='/login' element={<AccessoDaLink userService={userService} />}/>
                    <Route path='/reset-password-success' element={
                        <div className={'reset-password-success-container'}>
                            <ResetPasswordSuccess
                                history={history}
                                userService={userService}
                            />
                        </div>
                    }/>
                    <Route path='/reset-password-email' element={
                        <div className={'reset-password-container'}>
                            <ResetPasswordEmail
                                history={history}
                                userService={userService}
                            />
                        </div>
                    }/>
                    <Route path='/check-password' element={
                        <div className={'check-password-container'}>
                            <CheckPassword
                                history={history}
                                userService={userService}
                            />
                        </div>
                    }/>
                    <Route path='/forgot-password' element={
                        <div className={'forgotPassword-container'}>
                            <ForgotPassword
                                history={history}
                                userService={userService}
                            />
                        </div>
                    }/>
                    <Route path='/activate-account' element={<ContoInAttesa />} />
                    <Route path='/user/validate/:token' element={
                        <div className={'activate-account-email-container'}>
                            <ActivateAccountEmail
                                history={history}
                                userService={userService}
                            />
                        </div>
                    }/>
                    <Route path='/my-users' element={<Navigate to="/my-account/lista-utenti" replace />} />
                    <Route path='/my-tickets' element={
                        <div className={'login-container'}>
                            <MyTickets history={history} userService={userService} />
                        </div>
                    }/>
                    {/* Le quote sono dello sport: la pagina controlla da se' la
                        voce (SITE_ODDS_VIEW), qui si chiede la sezione della skin. */}
                    <Route path='/odds' element={
                        <ConVoce voce="SITE_ODDS_VIEW" quando={skinConScommesse}>
                            <div className={'login-container'}>
                                <OddsPage history={history} userService={userService} />
                            </div>
                        </ConVoce>
                    }/>
                    <Route path='/live-sport' element={
                        <SeSezione chiave={'liveSport'}>
                            <div className="live-sport-wrapper">
                                <LiveSportContainer />
                            </div>
                        </SeSezione>
                    }/>
                    {/* IL CASINO' E IL LIVE CASINO: la stessa lobby con la sua
                        sezione, e la pagina del gioco sotto la lobby. */}
                    <Route path='/live-casino' element={
                        <SeSezione chiave={'liveCasino'}>
                            <Lobby sezione={'liveCasino'} userService={userService}/>
                        </SeSezione>
                    }/>
                    <Route path='/live-casino/gioco/:id' element={
                        <SeSezione chiave={'liveCasino'}>
                            <PaginaGioco sezione={'liveCasino'} userService={userService}/>
                        </SeSezione>
                    }/>
                    <Route path='/casino' element={
                        <SeSezione chiave={'casino'}>
                            <Lobby sezione={'casino'} userService={userService}/>
                        </SeSezione>
                    }/>
                    <Route path='/casino/gioco/:id' element={
                        <SeSezione chiave={'casino'}>
                            <PaginaGioco sezione={'casino'} userService={userService}/>
                        </SeSezione>
                    }/>
                    <Route path='/poker' element={
                        <SeSezione chiave={'poker'}>
                            <div className="poker-container center white">
                                <p>{i18next.t('Poker')}</p>
                            </div>
                        </SeSezione>
                    }/>
                    {/* SPORT BETBY: lo sportsbook di Sunshine Hub, la pagina di
                        aeterium-sport-container in una cornice. */}
                    <Route path='/sport-betby' element={
                        <SeSezione chiave={'sportBetby'}>
                            <SportBetby/>
                        </SeSezione>
                    }/>
                    {/* VIRTUAL: la stessa lobby, con i giochi della sezione
                        virtualiCasino del catalogo casino'. */}
                    <Route path='/virtual' element={
                        <SeSezione chiave={'virtual'}>
                            <Lobby sezione={'virtual'} userService={userService}/>
                        </SeSezione>
                    }/>
                    <Route path='/virtual/gioco/:id' element={
                        <SeSezione chiave={'virtual'}>
                            <PaginaGioco sezione={'virtual'} userService={userService}/>
                        </SeSezione>
                    }/>
                    {/* CRASH GAME: la stessa lobby, con i giochi della sezione
                        crashGame del catalogo casino'. */}
                    <Route path='/crash-game' element={
                        <SeSezione chiave={'crashGame'}>
                            <Lobby sezione={'crashGame'} userService={userService}/>
                        </SeSezione>
                    }/>
                    <Route path='/crash-game/gioco/:id' element={
                        <SeSezione chiave={'crashGame'}>
                            <PaginaGioco sezione={'crashGame'} userService={userService}/>
                        </SeSezione>
                    }/>
                    {/* I RISULTATI DELLA RICERCA (modulo Ricerca giochi): ci porta la casella in testata. */}
                    <Route path='/cerca' element={<Ricerca userService={userService}/>}/>
                    {/* LA PAGINA DI UNA CATEGORIA SOLO DELLA HOME: tutti i suoi
                        giochi, a pagine. Ci portano il nome della riga in Home
                        e «Vedi tutti»; le schede di Casino' e Live casino hanno
                        la lobby (/casino?scheda=top10). */}
                    <Route path='/categoria/:id' element={<PaginaCategoria/>}/>
                    {/* LE PAGINE DI TESTO: Chi siamo, Regolamento e Assistenza
                        sono del modulo Aiuto (titolo e testo dalla skin;
                        spenta, l'indirizzo porta alla Home); Gioco
                        responsabile del modulo Pie' di pagina. */}
                    <Route path='/chi-siamo' element={<div className="home-container"><PaginaChiSiamo/></div>}/>
                    <Route path='/regolamento' element={<div className="home-container"><PaginaTesto chiave={'regolamento'}/></div>}/>
                    <Route path='/assistenza' element={<div className="home-container"><PaginaTesto chiave={'assistenza'}/></div>}/>
                    <Route path='/gioco-responsabile' element={<div className="home-container"><PaginaTesto chiave={'giocoResponsabile'} userService={userService}/></div>}/>
                    {/* Le pagine spente di serie finche' il testo non e' scritto (modulo Aiuto): collegate dal pie' di pagina. */}
                    <Route path='/termini-bonus' element={<div className="home-container"><PaginaTesto chiave={'terminiBonus'}/></div>}/>
                    <Route path='/privacy' element={<div className="home-container"><PaginaTesto chiave={'privacy'}/></div>}/>
                    <Route path='/cookie' element={<div className="home-container"><PaginaTesto chiave={'cookie'}/></div>}/>
                    {/* LE PAGINE DEL MENU (modulo Pagine): spente di serie; accese, compaiono nel menu. Spente, l'indirizzo porta alla Home. */}
                    <Route path='/promozioni' element={<div className="home-container"><Promozioni/></div>}/>
                    <Route path='/vip' element={<div className="home-container"><SpazioVip/></div>}/>
                    <Route path='/tornei' element={<div className="home-container"><Tornei/></div>}/>
                    <Route path='/fedelta' element={<div className="home-container"><PaginaScritta chiave={'fedelta'} userService={userService}/></div>}/>
                    <Route path='/ruota' element={<div className="home-container"><PaginaScritta chiave={'ruota'}/></div>}/>
                    <Route path='/hall-of-fame' element={<div className="home-container"><PaginaScritta chiave={'hallOfFame'}/></div>}/>
                    {/* LA HOME E' LA VETRINA, non la pagina Sport con un
                        altro nome. Prima qui c'era SportContainer con
                        path='home', che mostrava la vecchia vetrina con i
                        numeri finti scritti nel codice. */}
                    <Route path='/' element={
                        <div className="home-container">
                            <Vetrina userService={userService}/>
                        </div>
                    }/>
                </Routes>
                </React.Suspense>
            </div>
        );
    }
}

export default Main;
